import React from 'react';
import Header from '../../components/Header';
import TopNavBar from '../../components/TopNavBar';
import Footer from '../../components/Footer';
import SideControlPanel from '../../components/SideControlPanel';
import { Outlet } from 'react-router-dom';
import styles from './MainLayout.module.css';

export default function MainLayout() {
  return (
    <>
      <Header />
      <TopNavBar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
      <SideControlPanel />
    </>
  );
}
